import { PageHeader } from '@ant-design/pro-layout';
import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import { WebUxPage, WebUxPageContent, WebUxPageItem } from '../../webux-layouts/WebUxPage';
import Objective from './Objective';
import { useConnection } from '../../../../connection/Application';

const GoalView: FC = () => {
  const params = useParams<{ cycle: string; id: string; name: string }>();
  const [performanceCycles, setPerformanceCycles] = useState<any[]>([]);
  const history1 = useHistory();
  const connection = useConnection();

  useEffect(() => {
    const token = connection.hasSession();
    if (token) {
      connection.get('cycles').then(async (value) => {
        setPerformanceCycles(value.performanceCycle);
      });
    }
  }, [connection]);

  return (
    <WebUxPage>
      <PageHeader
        ghost={false}
        style={{ background: '#FFF' }}
        title={`${decodeURIComponent(params?.name)}`}
        subTitle="View Objective"
        onBack={() => history1.goBack()}
        breadcrumb={{
          items: [
            {
              path: 'goals',
              title: `Objectives`,
            },
            {
              path: 'goals',
              title: `${decodeURIComponent(params?.name)}`,
            },
          ],
        }}
      />
      <WebUxPageContent>
        <WebUxPageItem style={{ display: 'flex', justifyContent: 'center' }}>
          <div
            style={{
              width: '50%',
            }}>
            {performanceCycles?.find((e) => +e.id === +params.cycle) && (
              <Objective
                id={+params.id}
                performanceCycle={performanceCycles?.find((e) => +e.id === +params.cycle)}
                mode={'view'}
                disable={true}
              />
            )}
          </div>
        </WebUxPageItem>
      </WebUxPageContent>
    </WebUxPage>
  );
};

export default GoalView;
